<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    {{Title}}
</h1>

<div *ngIf="initInfo.operation == 'formOpen'" class="execution-time-div">

    @if(ShowTimeElapsed){
        <div class="execution-time-div">
            <span>Execution Time:</span>
            <span [ngClass]="this.JobInProgress ? 'active-execution-time-span' : 'idle-execution-time-span'">{{this.JobTimeElapsed}}</span>
        </div>
    }

    <div class="execution-status-div">
        <span>Execution Status:</span>
        <span [ngClass]="this.JobCompleted ? 'completed-execution-status-span' : 'incomplete-execution-status-span'">{{this.Status}}</span>
    </div>

    <mat-checkbox class="show-log-checkbox" [checked]="ViewFormSaveLog || JobErrorOccurred" (change)="toggleViewFormSaveLog()">View Log?</mat-checkbox>
    @if(ViewFormSaveLog || JobErrorOccurred){
        <ng-container>
            <div class="execution-summary-div tall-execution-summary-div">
                <p [ngClass]="this.JobErrorOccurred ? 'execution-summary-p execution-summary-with-error-p' : 'execution-summary-p execution-summary-without-error-p'"
                   data-placeholder="Details will display here ...">{{this.ExecutionSummaryText}}</p>
            </div>
        </ng-container>
    }

    <div class="dialog-message">Dialog will close automatically when Form loading completes</div>
</div>

<ng-container *ngIf="initInfo.operation != 'formOpen'">
    <mat-dialog-content>
        <div *ngIf="initInfo.operation == 'formSaveWithTransition'" class="execution-time-div">
            <span>{{initInfo.transitionMessage}}</span>
        </div>

        <div class="execution-time-div">
            <span>Execution Time:</span>
            <span [ngClass]="this.JobInProgress ? 'active-execution-time-span' : 'idle-execution-time-span'">{{this.JobTimeElapsed}}</span>
        </div>

        <div class="execution-status-div">
            <span>Execution Status:</span>
            <span [ngClass]="this.JobCompleted ? 'completed-execution-status-span' : 'incomplete-execution-status-span'">{{this.Status}}</span>
        </div>

        <div class="buttons">
            <button *ngIf="showStartOperationManuallyButton()"
                    mat-flat-button
                    class="button"
                    type="submit"
                    color="accent"
                    [disabled]="this.JobInProgress"
                    (click)="this.startOperationManually()">
                OK
            </button>

            <button *ngIf="showDismissButton()"
                    mat-flat-button
                    class="button"
                    type="submit"
                    color="accent"
                    [disabled]="disableDismissButton()"
                    (click)="this.dismissClicked(false)">
                {{this.DismissButtonTitle}}
            </button>

            <button *ngIf="showGoToSiteHomePageButton()"
                    mat-flat-button
                    class="button"
                    type="submit"
                    color="accent"
                    [disabled]="!this.JobCompleted"
                    (click)="this.goToSiteHomePage()">
                Go to Site Homepage
            </button>

            <button *ngIf="showDismissWithReloadButton()"
                    mat-flat-button
                    class="button"
                    type="submit"
                    color="accent"
                    (click)="this.dismissClicked(true)">
                Complete
            </button>

        </div>

        <mat-checkbox [checked]="ViewFormSaveLog || JobErrorOccurred" (change)="toggleViewFormSaveLog()">View Form Save Log?</mat-checkbox>
    </mat-dialog-content>
    <ng-container *ngIf="ViewFormSaveLog || JobErrorOccurred">
        <div class="execution-summary-div tall-execution-summary-div">
            <p [ngClass]="this.JobErrorOccurred ? 'execution-summary-p execution-summary-with-error-p' : 'execution-summary-p execution-summary-without-error-p'"
               data-placeholder="Details will display here ...">{{this.ExecutionSummaryText}}</p>
        </div>

        <div class="buttons">
            <ng-container *ngIf="this.JobErrorOccurred">
                <button mat-flat-button
                        type="submit"
                        color="accent"
                        [disabled]="!this.JobErrorOccurred"
                        (click)="this.copyJobErrorTextToClipboard()">
                    Copy Error Text
                </button>
            </ng-container>
        </div>
    </ng-container>
